/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Challenge_DescriptionInputs */

const en_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 30 Daily Challenges to unlock this new plant.`)
};

const ar_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل 30 تحديًا يوميًا لفتح هذه النبتة الجديدة.`)
};

const de_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe 30 tägliche Herausforderungen ab, um diese neue Pflanze freizuschalten.`)
};

const es_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 30 desafíos diarios para desbloquear esta nueva planta.`)
};

const fr_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminez 30 défis quotidiens pour débloquer cette nouvelle plante.`)
};

const it_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa 30 sfide giornaliere per sbloccare questa nuova pianta.`)
};

const ja_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デイリーチャレンジを30個完了して、この新しい植物をアンロックしましょう。`)
};

const ko_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 새로운 식물을 잠금 해제하려면 일일 챌린지를 30개 완료하세요.`)
};

const pt_br_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua 30 desafios diários para desbloquear esta nova planta.`)
};

const ru_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполните 30 ежедневных заданий, чтобы открыть это новое растение.`)
};

const th_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความท้าทายประจำวัน 30 ครั้งเพื่อปลดล็อกต้นไม้ใหม่นี้`)
};

const tr_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu yeni bitkinin kilidini açmak için 30 Günlük Mücadeleyi tamamlayın.`)
};

const zh_cn_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 30 个每日挑战，就能获得这棵植物！`)
};

const zh_tw_monthly_challenge_description = /** @type {(inputs: Monthly_Challenge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成 30 個每日挑戰，就能獲得這棵植物！`)
};

/**
* | output |
* | --- |
* | "Complete 30 Daily Challenges to unlock this new plant." |
*
* @param {Monthly_Challenge_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_challenge_description = /** @type {((inputs?: Monthly_Challenge_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Challenge_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_challenge_description(inputs)
	if (locale === "ar") return ar_monthly_challenge_description(inputs)
	if (locale === "de") return de_monthly_challenge_description(inputs)
	if (locale === "es") return es_monthly_challenge_description(inputs)
	if (locale === "fr") return fr_monthly_challenge_description(inputs)
	if (locale === "it") return it_monthly_challenge_description(inputs)
	if (locale === "ja") return ja_monthly_challenge_description(inputs)
	if (locale === "ko") return ko_monthly_challenge_description(inputs)
	if (locale === "pt_br") return pt_br_monthly_challenge_description(inputs)
	if (locale === "ru") return ru_monthly_challenge_description(inputs)
	if (locale === "th") return th_monthly_challenge_description(inputs)
	if (locale === "tr") return tr_monthly_challenge_description(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_challenge_description(inputs)
	return zh_tw_monthly_challenge_description(inputs)
});